export default __webpack_public_path__ + "static/media/coming_naka.d2e728cc.png";